import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#52B2BF", // teal accent
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#E6DBAC", // tan accent
      contrastText: "#000000",
    },
    text: {
      primary: "#1a1a1a",
      secondary: "#4a4a4a",
    },
    background: {
      default: "#ffffff",
      paper: "#f7f7f7",
    },
  },
  typography: {
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h2: { fontWeight: 700 },
    h4: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 10 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 14 },
      },
    },
  },
});

export default theme;
